import React, { useContext } from "react";
import { RouteComponentProps } from "react-router-dom";
import Header from "components/Header";
import { CourseContext } from "../../Store";
import Boundary from "components/Boundary";
import { DiscussProvider } from "./provider";
import { AskTeacherDetailInner } from "../../../AskTeacher/AskTeacherDetail";
import { TopicType } from "service/discuss";

type DiscussDetailProps = RouteComponentProps<{ uuid: string }>;

export function DiscussDetail({ match }: DiscussDetailProps) {
    const { uuid } = match.params;

    const {
        course: { courseNo, batchNo, courseSeq }
    } = useContext(CourseContext);

    return (
        <DiscussProvider
            topicType={TopicType.Discuss}
            uuid={uuid}
            courseNo={courseNo}
            batchNo={batchNo!}
            courseSeq={courseSeq}>
            <Header />

            <Boundary>
                <AskTeacherDetailInner />
            </Boundary>
        </DiscussProvider>
    );
}
